/*eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import { defaultStore } from "./defaultStore";
import { vesselStore } from "./vesselsListStore";

Vue.use(Vuex);

// Export the instantiated store directly
export const store = new Vuex.Store({
    modules: {
        defaultStore,
        vesselStore,
    },
});